import { ApolloGraphQLError, ApolloNetworkError } from "../apollo/error";
import type { UserFacingErrorSourceId } from "./reportUserFacingErrorScreen";

export const classifyErrorSource = (
  error: Error | undefined,
  fallback: UserFacingErrorSourceId,
): UserFacingErrorSourceId => {
  if (error instanceof ApolloNetworkError) {
    return "network";
  }
  if (error instanceof ApolloGraphQLError) {
    return "apollo";
  }
  return fallback;
};
